
import { LocateFixed } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCamera } from "../hooks/useCamera";

/**
 * Reset-view button — returns the camera to the computed "home" viewpoint
 * (the optimal overview derived from the scene's terrain and objects).
 * Triggers a smooth transition via the store's homeRequest signal.
 */
export function ResetViewButton() {
  const { requestHome } = useCamera();

  return (
    <button
      onClick={requestHome}
      className={cn(
        "flex items-center justify-center min-w-[40px] min-h-[40px] rounded-lg",
        "backdrop-blur-sm border transition-colors cursor-pointer",
        "bg-sands-50/90 border-sands-200 text-sands-500 hover:bg-sands-100/90 hover:text-sands-600",
      )}
      title="Reset view — return to the default overview"
    >
      <LocateFixed className="w-4 h-4 shrink-0" />
    </button>
  );
}
